module.exports = __webpack_public_path__ + "assets/img/23_143_big.8f11b4d6.jpg";